import { Card, Col, Form, Input, Row } from "antd";
import { useTranslation } from "react-i18next";
import { FaPhone } from "react-icons/fa6";
import { useState } from "react";
import CardTitle from "components/CardTitle";
import PhoneInputImport from "react-phone-input-2";

const PhoneInput = ((PhoneInputImport as any).default ?? PhoneInputImport) as typeof PhoneInputImport;

export default function ContactInfoForm(): React.ReactElement {
  const { t } = useTranslation();
  const [phoneNumber, setPhoneNumber] = useState<string | null | undefined>();
  const [phoneNumber2, setPhoneNumber2] = useState<string | null | undefined>();

  return (
    <Col xs={24} sm={12}>
      <Card
        title={<CardTitle icon={<FaPhone />} title={t("Contact details")} />}
        className="antd-newrai-card"
      >
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={12}>
            <Form.Item name="email" label={t("Email")}>
              <Input />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12}>
            <Form.Item name="phone1" label={t("Phone")}>
              <PhoneInput
                placeholder=""
                containerClass="custom-phone-input"
                country={"fr"}
                value={phoneNumber}
                onChange={value => setPhoneNumber(value)}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12}>
            <Form.Item name="phone2" label={t("Telephone")}>
              <PhoneInput
                placeholder=""
                containerClass="custom-phone-input"
                country={"fr"}
                value={phoneNumber2}
                onChange={value => setPhoneNumber2(value)}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12}>
            <Form.Item name="fax" label={t("Fax")}>
              <PhoneInput placeholder="" containerClass="custom-phone-input" country={"fr"} />
            </Form.Item>
          </Col>
        </Row>
      </Card>
    </Col>
  );
}
